<template>
  <div id="app" class="text-white md:px-10 md:pt-10 md:pb-20 mt-12 px-8 pt-8 pb-16 min-h-screen">
    <Navigation/>
    <router-view/>
  </div>
</template>

<script>
import Navigation from './components/Navigation.vue';

export default {
  name: 'App',
  components: {
    Navigation
  }
};
</script>

<style lang="scss">
body, #app {
  background-repeat: no-repeat;
  background-size: contain;
  background-attachment: fixed;
}

body {
  background-image: url('https://www.thenosleeppodcast.com/wp-content/themes/nosleep-bridge-child/img/footer4.png');
  background-position: bottom;
  background-color: #16181b;
}

#app {
  background-image: url('https://www.thenosleeppodcast.com/wp-content/themes/nosleep-bridge-child/img/bg-header.png');
  background-position: 0 3rem;
}
</style>
